import type {
  Cables,
  Casings,
  Intakes,
  Maybe,
  Motors,
  Pumps,
  Seals,
  Tubings
} from "gql/api";

export enum EquipSelectEnum {
  Casings = "casings",
  Tubings = "tubings",
  Intakes = "intakes",
  Cables = "cables",
  Pumps = "pumps",
  Motors = "motors",
  Seals = "seals",
  None = "none"
}

export type QueryEquipment =
  | Casings[]
  | Tubings[]
  | Intakes[]
  | Cables[]
  | Pumps[]
  | Motors[]
  | Seals[];

export type EquipmentItem = {
  imperial_name?: Maybe<string>;
  metric_name?: Maybe<string>;
  manufacturer?: Maybe<string>;
  intake_type?: Maybe<string>;
  part_number?: Maybe<number>;
  gauge?: Maybe<number>;
  nameplate_horsepower?: Maybe<number>;
  nameplate_voltage?: Maybe<number>;
  nameplate_current?: Maybe<number>;
  length_inches?: Maybe<number>;
  series_model?: Maybe<string>;
  configuration?: Maybe<string>;
  id: number;
  kv?: Maybe<number>;
  construction?: Maybe<string>;
  outer_diameter_inches?: Maybe<number>;
};

export interface EquipmentType {
  label: string;
  value: string;
}

export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const defaultEquipmentSelection = () => {
  return {
    [EquipSelectEnum.Casings]: [],
    [EquipSelectEnum.Tubings]: [],
    [EquipSelectEnum.Intakes]: [],
    [EquipSelectEnum.Cables]: [],
    [EquipSelectEnum.Pumps]: [],
    [EquipSelectEnum.Motors]: [],
    [EquipSelectEnum.Seals]: [],
    [EquipSelectEnum.None]: []
  };
};
